/**
 /**
 * created by tianruojun
 * 部分稿件操作按钮状态
 */
export const showBtnConfig = {
    publishBtn: {
        evl: "actButonsdata.length == 0"
    }
};